export default __webpack_public_path__ + "static/media/save_ic.e9d3ea41.svg";